import * as actions from '../actions/index';
import { HttpClient } from "../apiCalls/httpClient";
import _ from "lodash"

let productHistoryData = []


const productHistory = (state = productHistoryData, action) => {
  //console.log("hello from the reducer CA!", action.type)
  let pHistory = [];
  let newState;
  let prodHist;
  switch(action.type)
  {
      case actions.INITIATE_DATA:
        pHistory = action.payload;
        //console.log("inititate_data reducer:", action.payload)
        return Object.assign({}, state, {"productHistory": pHistory})     
      case actions.DELETE_DATA:
        //console.log(state, action.payload, "prodHist reducer")
        newState = _.cloneDeep(state)
        prodHist = newState.productHistory.filter((item) => {
          return item.productLineId != action.payload
        })
        newState.productHistory = prodHist
        return newState
      case actions.UPDATE_DATA:
        console.log("update prodlist reducer:", action.payload)
        newState = _.cloneDeep(state)
        prodHist = newState.productHistory.findIndex(item => item.productLineId === action.payload.productLineId)
        newState.productHistory[prodHist] = action.payload
        return newState;
      default:  
          return state;
  }
}

export default productHistory;